import { Injectable } from '@angular/core';
import { v4 as uuid } from 'uuid';

import { UserService } from '../_services/user.service'

import { EventEmitter } from '@angular/core';

export const ACTIVE_TASK_USER_CONFIG_KEY = "active_task_key"

@Injectable()
export class LongProgressService {

  // public ACTIVE_TASK_USER_CONFIG_KEY = 'active_task_key'

  private progessResult
  private checkStatusInterval
  private taskId
  activeTasks: Object = {}

  showProgressEvent: EventEmitter<any> = new EventEmitter();
  progressCompletedEvent: EventEmitter<any> = new EventEmitter();
  progressPollingEvent: EventEmitter<any> = new EventEmitter();
  notificationOpenEvent: EventEmitter<Object> = new EventEmitter();
  currentNotificationTab: EventEmitter<Object> = new EventEmitter();

  constructor(
              private userService: UserService) {
               }

  public showProgress(title: String, message: String, taskId: String, activeProjectID: string, type: String,  icon: string, parentId: String=null, estimatedTime:any=null, startTime:any=null) {
    let id = uuid()
    this.showProgressEvent.emit({
      title: title,
      message: message,
      taskId: taskId,
      parentId: parentId,
      activeProjectID: activeProjectID,
      type: type,
      icon: icon,
      id: id,
      estimatedTime: estimatedTime,
      startTime: startTime
    })
    console.log(title)
    this.activeTasks = this.userService.getConfig(ACTIVE_TASK_USER_CONFIG_KEY) || {}
    this.activeTasks[activeProjectID] = {
      'title': title,
      'message': message,
      'taskId': taskId,
      'parentId': parentId,
      'activeProjectID': activeProjectID,
      'type': type,
      'icon': icon,
      'id': id,
      'created_at': (new Date()).toUTCString(),
      'estimatedTime': estimatedTime,
      'startTime': startTime ? startTime.$date : null
    }
    this.userService.setConfig(ACTIVE_TASK_USER_CONFIG_KEY, this.activeTasks)
    return id
  }

  public resumeProgress(task) {
    this.showProgressEvent.emit({
      'title': task["title"],
      'message': task["message"],
      'taskId': task['taskId'],
      'parentId': task['parentId'],
      'activeProjectID': task["activeProjectID"],
      'type': task["type"],
      'icon': task["icon"],
      'id': task["id"],
      'estimatedTime': task["estimatedTime"],
      'startTime': task["startTime"] ? {$date: task["startTime"]} : null
    })
  }

  // public showProgress(message: String, taskId: String, activeProjectID: String) {
  //     console.log("progress request got")
  //     var data = {
        // message: message,
        // taskId: taskId,
        // activeProjectID: activeProjectID
  //     }
  //     this.showProgressEvent.emit("data")
  //     this.testEvent.emit("working");
  //     // this.checkStatusInterval = setInterval(() => {
  //     //   this.ingetionService.checkStatus(activeProjectID, taskId).subscribe((result) => {
  //     //     this.progessResult = result
  //     //     this.updateProgress()
  //     //   })
  //     // }, 2000)
  //     this.showProgressEvent.subscribe((data) => {
  //       console.log("working here");
  //     })
  // }
  

  // private updateProgress() {
  //   this.progressUpdateEvent.emit(this.progessResult)
  //   console.log(this.progessResult)
  // }

}
